import * as React from 'react';
import {
    Edit,
    TextInput,
    BooleanInput,
    Toolbar,
    FormWithRedirect,
    required,
    minLength,
    maxLength,
} from 'react-admin';
import { Box, Card, CardContent } from '@material-ui/core';

const NewsTypeEdit = (props: any) => (
    <Edit undoable={false} component="div" {...props}>
        <NewsTypeForm />
    </Edit>
);

const NewsTypeForm = (props: any) => {
    const validateName = [required(), minLength(1), maxLength(100)];
    return (
        <FormWithRedirect
            {...props}
            redirect="list"
            render={(formProps: any) => (
                <Card>
                    <form>
                        <CardContent>
                            <Box display={{ md: 'block', lg: 'flex' }}>
                                <Box flex={2} mr={{ md: 0, lg: '1em' }}>
                                    <TextInput
                                        source="name"
                                        label="resources.news_types.fields.name"
                                        validate={validateName}
                                        fullWidth
                                    />
                                    <BooleanInput
                                        source="is_enabled"
                                        label="resources.news_types.fields.is_enabled"
                                    />
                                </Box>
                            </Box>
                        </CardContent>
                        <Toolbar
                            record={formProps.record}
                            basePath={formProps.basePath}
                            invalid={formProps.invalid}
                            handleSubmit={formProps.handleSubmit}
                            saving={formProps.saving}
                            resource="news_types"
                        />
                    </form>
                </Card>
            )}
        />
    );
};

export default NewsTypeEdit;
